// import { defineStore } from 'pinia'
// import { ref, toRaw } from 'vue'

import { collection, doc, query, where, updateDoc } from "firebase/firestore"

// import { useMainStore } from '~/stores/main'
export const useDataStore = defineStore("data", () => {
	const toast = useToast()
	const prefix = "__"
	const context = ref(<tsAppendableObj>{
		import_details: false,
		import_status: "",
		is_loading: true,
		whats: [
			{ what: "_users", prefix: "", type: "admin", context: "BASE" },
			// { what: "users_public", prefix: prefix, type: "admin" },
			{ what: "base_langs", prefix: prefix, type: "app", context: "BASE" },

			{ what: "users_roles", prefix: prefix, type: "app", context: "BASE" },
			{ what: "users_private", prefix: prefix, type: "private", context: "BASE" },
			{ what: "users_public", prefix: prefix, type: "app", context: "BASE" },

			{ what: "base_companies", prefix: prefix, type: "app", context: "BASE" },
			{ what: "base_companies_users", prefix: prefix, type: "app", context: "BASE" },
			{ what: "base_subscriptions", prefix: prefix, type: "app", context: "BASE" },
			{ what: "base_subscriptions_price", prefix: prefix, type: "app", context: "BASE" },
			{ what: "base_companies_subscriptions", prefix: prefix, type: "app", context: "BASE" },

			{ what: "dextools_tests_inputs", prefix: prefix, type: "app", context: "BASE" },
			{ what: "dextools_tests_expected", prefix: prefix, type: "app", context: "BASE" },
			{ what: "dextools_tests_results", prefix: prefix, type: "app", context: "BASE" },

			{ what: "dextools_tests", prefix: prefix, type: "app", context: "BASE" },
			{ what: "dextools_tests_unit", prefix: prefix, type: "app", context: "BASE" },

			{ what: "emailtemplates", prefix: prefix, type: "app", context: "BASE" },

			// { what: "langs", prefix:prefix},
		],
	})

	const options = ref({
		toogle_inactive: <boolean>false,
		api_key: localStorage.getItem("api_key") ? localStorage.getItem("api_key") : "",
		reset_trigger: localStorage.getItem("reset_trigger")
			? JSON.parse("" + localStorage.getItem("reset_trigger"))
			: false,
		saved_local: localStorage.getItem("api_key") === null || localStorage.getItem("api_key") === "" ? false : true,
	})

	function saveApiKeyToLocalStorage() {
		localStorage.setItem("api_key", "" + options.value.api_key)
		localStorage.setItem("reset_trigger", JSON.stringify(options.value.reset_trigger))
		console.log("saveToLocalStorage", "done")
	}

	const holders_vuefire = ref(<tsAppendableObj>{})
	const holders_local = ref(<tsAppendableObj>{})

	const bool_log_set = false

	function initLangsData(HandlerStore: any, do_what: string) {
		const db = useFirestore()
		if (do_what === "destroy") {
			for (const what of HandlerStore.context.whats) {
				holders_vuefire.value[what.what] = null //=useCollection(collection(db, what.what))
			}
			return
		}
		for (const what of HandlerStore.context.whats) {
			if (what.type === "app" && what.what.endsWith("_langs")) {
				if (bool_log_set) console.log("initApp", what)
				if (do_what === "update") {
					// if (!HandlerStore.holders_vuefire[what.what])
					holders_vuefire.value[what.what] = useCollection(collection(db, what.what))
				} else if (do_what === "set") {
					holders_vuefire.value[what.what] = useCollection(collection(db, what.what)) //=useCollection(collection(db, what.what))
					// console.log(holders_vuefire[what.what])
				}
				// console.log(holders_vuefire[what.what])
			}
		}
	}

	function initAppData(HandlerStore: any, do_what: string, user_full: any) {
		// HandlerStore.initApp(do_what, user_full)
		HandlerStore.context.is_loading = true
		if (bool_log_set) console.log("initApp START", do_what, user_full)
		const db = useFirestore()
		if (do_what === "destroy") {
			for (const what of HandlerStore.context.whats) {
				holders_vuefire.value[what.what] = null //=useCollection(collection(db, what.what))
			}
			return
		}
		for (const what of HandlerStore.context.whats) {
			if (bool_log_set) console.log("initApp", what)
			if (what.type === "app") {
				if (do_what === "update") {
					// if (!HandlerStore.holders_vuefire[what.what])
					holders_vuefire.value[what.what] = useCollection(collection(db, what.what))
				} else if (do_what === "set") {
					holders_vuefire.value[what.what] = useCollection(collection(db, what.what)) //=useCollection(collection(db, what.what))
					// console.log(holders_vuefire[what.what])
				}
				// console.log(holders_vuefire[what.what])
			} else if (what.type === "owners") {
				if (user_full?.auth) {
					if (do_what === "update") {
						if (!holders_vuefire.value[what.what]) {
							holders_vuefire.value[what.what] = useCollection(
								query(
									// you can pass a query into useCollection
									collection(db, what.what), // go to the sessions collection
									where("owner_uid", "==", user_full.auth.uid), // only get the ones that belong to the user.
								),
							)
						}
					} else if (do_what === "set") {
						holders_vuefire.value[what.what] = useCollection(
							query(
								// you can pass a query into useCollection
								collection(db, what.what), // go to the sessions collection
								where("owner_uid", "==", user_full.auth.uid), // only get the ones that belong to the user.
							),
						)
					}
				}
				// console.log(holders_vuefire[what.what])
			} else if (what.what.endsWith("_private")) {
				if (user_full?.auth) {
					if (bool_log_set) console.log("initApp ADMINS", what.what, user_full.auth.uid, HandlerStore.holders_vuefire)
					holders_vuefire.value[what.what] = useDocument(doc(db, what.what, user_full.auth.uid))
				}
			}
		}
		// console.log("initApp END")
		HandlerStore.context.is_loading = false
	}

	const langs_entries = computed(() => {
		const out = <tsAppendableObj>{}
		if (holders_vuefire.value["base_langs"] && holders_vuefire.value["base_langs"].length > 0) {
			out["base_langs"] = holders_vuefire.value["base_langs"].reduce((acc: tsAppendableObj, current, index) => {
				acc[current.id] = current
				return acc
			}, {})
			// console.log(out["base_langs"])
		}
		if (holders_vuefire.value["main_langs"] && holders_vuefire.value["main_langs"].length > 0) {
			out["main_langs"] = holders_vuefire.value["main_langs"].reduce((acc: tsAppendableObj, current, index) => {
				acc[current.id] = current
				return acc
			}, {})
			// console.log(out["main_langs"])
		}
		return out
	})

	async function destroyLocalData(HandlerStore: any) {
		initAppData(HandlerStore, "destroy", null)

		// console.log(user_role_apps)

		// user_full.value = { auth: user, roles: user_roles }
	}

	async function getApiData(
		apiHost: any,
		apiName: any,
		api_key: any,
		operation: any,
		payload: any,

		lazy: boolean = false,
	) {
		try {
			const res = await $fetch(apiHost + "/api/" + apiName + "/all", {
				method: "POST",
				lazy: lazy,
				headers: {
					"Content-Type": "application/json",
					"Access-Control-Allow-Origin": "*",
					"Access-Control-Allow-Headers": "*",
				},
				body: {
					operation: operation,
					api_key: api_key,
					payload,
				},
			})
			toast.add({
				title: "Success!",
				description: "API operation [" + operation + "] succeeded.",
				color: "success",
			})
			return res
		} catch (error: any) {
			console.error("getApiData error:", JSON.stringify(error.data))
			const backendMessage = error?.data?.error || "An unknown API error occurred."

			toast.add({
				title: "API Error",
				description: backendMessage,
				color: "error",
			})
			return {
				error: true,
				message: backendMessage,
				details: error,
			}
		}
	}

	const wbks_loaded_data = ref(<tsAppendableObj>{})

	const holders_file_uploads = ref(<tsAppendableObj>{})

	const holders_pdfs = ref(<tsAppendableObj>{})

	// type CallbackFunction = (message: any) => void

	// const finalCallback: CallbackFunction = (message) => {
	// 	console.log("Callback completed for message: " + message)
	// }
	// const gg = () => {
	// 	console.log("gg")
	// }

	return {
		context,
		options,
		initAppData,
		initLangsData,
		destroyLocalData,
		getApiData,
		saveApiKeyToLocalStorage,
		holders_vuefire,
		wbks_loaded_data,

		holders_pdfs,
		holders_local,
		holders_file_uploads,

		langs_entries,
		// dextools_qrs,
		// dextools_tests,
		// dextools_tests_inputs,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useDataStore, import.meta.hot))
}
